import { Breadcrumb, Button, Col, Form, Row, Steps } from "antd";
import { convertPersian, regexFormater, validateInput } from "../../../../tools/tools";
import ReactInputMask from "react-input-mask";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { HomeOutlined } from "@ant-design/icons";
import { _adr } from "../../../../address";
import "../paybill.scss";
import "./valid.scss";
import { useDealer } from "../../../../tools/api";
import { useDispatch } from "react-redux";
import { clearFormData } from "../../../../reducer/serviceReducer";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const ValidPayBill = () => {
	const [t] = useTranslation("global");
	const [frmPayBill] = Form.useForm();

	const location = useLocation();
	const dispatch = useDispatch();
	const { queryHotBill } = useDealer();
	const nav = useNavigate();

	const [bill, setBill] = useState({
		purchase: location?.state || null,
		msisdn: location?.state?.msisdn || location?.state?.inT_MSISDN || "",
		valmsisdn: "",
	});

	useEffect(() => {
		if (bill?.msisdn) {
			frmPayBill.setFieldValue("msisdn", bill?.msisdn);
			loadPayBill();
		}
	}, []);

	const loadPayBill = async (values = null) => {
		dispatch(clearFormData(["paybill"]));

		let payload = {
			msisdn: bill?.msisdn || regexFormater(values.msisdn).removeSpace(),
			withdebt: true,
		};
		const response = await queryHotBill(payload);
		if (response) {
			nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Prefactor, {
				state: {
					...response,
					msisdn: payload.msisdn,
				},
			});
		}
	};

	const handleSubmit = async (values) => {
		if (values.msisdn) {
			loadPayBill(values);
		}
	};
	return (
		<>
			<div className="container-main container-paybill">
				<div className="g-hold-title-of-page">
					<Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("payBill.title") }]} />
					<div className="title-page">
						<h3>{t("payBill.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main paybill-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={0}
											items={[
												{
													title: "صورتحساب",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "رسید",
												},
											]}
										/>
									</div>
								</div>
								<div className="bill-container">
									<div className="holder-paybill">
										<div className="title-page">
											<h3>لطفا شماره دائمی خودتان را وارد کنید.</h3>
										</div>
										<div className="holder-form">
											<Form id="frmPayBill" form={frmPayBill} onFinish={handleSubmit} layout="vertical">
												<Row>
													<Col xl={8} lg={12} md={24} xs={24} sm={24}>
														<Form.Item
															className="input-normal"
															label="شماره موبایل"
															name="msisdn"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "msisdnOrg",
																}),
															]}>
															<div>
																<ReactInputMask
																	value={frmPayBill.getFieldValue("msisdn")?.length > 0 ? frmPayBill.getFieldValue("msisdn") : ""}
																	onChange={(e) => {
																		e.target.value = convertPersian(e.target.value);
																		setBill((bill) => ({ ...bill, valmsisdn: e.target.value }));
																	}}
																	className="msisdn-mask"
																	dir="ltr"
																	mask="0\9\9\91 99 99 99"
																/>
															</div>
														</Form.Item>
													</Col>
													<Col span={7}></Col>
												</Row>
											</Form>
										</div>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button htmlType="submit" key={frmPayBill} form="frmPayBill" className="btn-normal btn-aptel" type="primary" danger>
										مرحله بعد
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default ValidPayBill;
